import { AutomationTestingProps } from '@/types';

import { Button } from '@@/buttons';

interface Props extends AutomationTestingProps {
  isRetrying: boolean;
  onRetry: () => void;
}

export function RetryButton({ isRetrying, onRetry, 'data-cy': dataCy }: Props) {
  return (
    <Button
      color="default"
      size="small"
      disabled={isRetrying}
      onClick={onRetry}
      data-cy={dataCy}
    >
      Retry
    </Button>
  );
}
